module.exports = __webpack_public_path__ + "img/sunset-2.72a5839e.jpg";